const x = (i, n) => {
  const t = (s) => {
    const o = i.parentElement || document.body, c = o.offsetWidth, l = o.offsetHeight, { clientWidth: a, clientHeight: m } = document.documentElement, f = s.offsetX, E = s.offsetY, p = (e) => {
      let u = e.x + document.body.scrollLeft - document.body.clientLeft - f, d = e.y + document.body.scrollTop - document.body.clientTop - E;
      u = u < 1 ? 1 : u < a - c - 1 ? u : a - c - 1, d = d < 1 ? 1 : d < m - l - 1 ? d : m - l - 1, n ? n(u, d) : (o.style.left = u + "px", o.style.top = d + "px");
    };
    document.addEventListener("mousemove", p);
    const h = () => {
      document.removeEventListener("mousemove", p), document.removeEventListener("mouseup", h);
    };
    document.addEventListener("mouseup", h);
  };
  return i.addEventListener("mousedown", t), () => {
    i.removeEventListener("mousedown", t);
  };
}, v = (i, n, t = "") => {
  var o;
  const s = document.getElementById(n.id);
  if (s)
    t !== "" && (Reflect.get(window, t) ? (o = n.onload) == null || o.call(s, new Event("load")) : n.onload && s.addEventListener("load", n.onload));
  else {
    const c = { ...n };
    c.onload = null;
    const l = w(i, c);
    n.onload && l.addEventListener("load", n.onload), document.head.appendChild(l);
  }
}, M = (i, n) => {
  const t = document.getElementById(n.id);
  t == null || t.remove(), v(i, n);
}, w = (i, n) => {
  const t = document.createElement(i);
  return Object.keys(n).forEach((s) => {
    n[s] !== void 0 && (t[s] = n[s]);
  }), t;
}, D = /* @__PURE__ */ (() => {
  const i = (t) => {
    if (!t)
      return;
    const s = t.firstChild;
    let o = 1, c = 0, l = 0, a = !1, m, f, E, p = 1;
    const h = () => {
      s.style.transform = `translate(${c}px, ${l}px) scale(${o})`;
    };
    t.addEventListener(
      "touchstart",
      (e) => {
        e.touches.length === 1 ? (a = !0, m = e.touches[0].clientX - c, f = e.touches[0].clientY - l) : e.touches.length === 2 && (E = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        ), p = o);
      },
      {
        passive: !1
      }
    ), t.addEventListener(
      "touchmove",
      (e) => {
        if (e.preventDefault(), a && e.touches.length === 1)
          c = e.touches[0].clientX - m, l = e.touches[0].clientY - f, h();
        else if (e.touches.length === 2) {
          const d = Math.hypot(
            e.touches[0].clientX - e.touches[1].clientX,
            e.touches[0].clientY - e.touches[1].clientY
          ) / E, r = o;
          o = p * (1 + (d - 1));
          const L = (e.touches[0].clientX + e.touches[1].clientX) / 2, Y = (e.touches[0].clientY + e.touches[1].clientY) / 2, X = s.getBoundingClientRect(), g = (L - X.left) / r, y = (Y - X.top) / r;
          c -= g * (o - r), l -= y * (o - r), h();
        }
      },
      {
        passive: !1
      }
    ), t.addEventListener("touchend", () => {
      a = !1;
    }), t.addEventListener(
      "wheel",
      (e) => {
        e.preventDefault();
        const u = 0.02, d = o;
        e.deltaY < 0 ? o += u : o = Math.max(0.1, o - u);
        const r = s.getBoundingClientRect(), L = e.clientX - r.left, Y = e.clientY - r.top;
        c -= L / d * (o - d), l -= Y / d * (o - d), h();
      },
      {
        passive: !1
      }
    ), t.addEventListener("mousedown", (e) => {
      a = !0, m = e.clientX - c, f = e.clientY - l;
    }), t.addEventListener("mousemove", (e) => {
      a && (c = e.clientX - m, l = e.clientY - f, h());
    }), t.addEventListener("mouseup", () => {
      a = !1;
    }), t.addEventListener("mouseleave", () => {
      a = !1;
    });
  };
  return (t) => {
    t.forEach((s) => {
      i(s);
    });
  };
})();
export {
  v as a,
  x as k,
  M as u,
  D as z
};
